import { render, staticRenderFns } from "./gridEnsaios.vue?vue&type=template&id=1d694e58"
import script from "./gridEnsaios.ts?vue&type=script&lang=js&external"
export * from "./gridEnsaios.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d694e58')) {
      api.createRecord('1d694e58', component.options)
    } else {
      api.reload('1d694e58', component.options)
    }
    module.hot.accept("./gridEnsaios.vue?vue&type=template&id=1d694e58", function () {
      api.rerender('1d694e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/fichaTecnica/gridEnsaios.vue"
export default component.exports